import { createLoader, parseAsArrayOf, parseAsInteger, parseAsStringEnum } from 'nuqs/server';
import { AREA_SWEDEN } from '@/constants/globals';
import { AreaType } from '@/types/booliApi';

const keyMaps = {
  areaMode: parseAsStringEnum(Object.values(AreaType)).withDefault(AreaType.County),
  areaIds: parseAsArrayOf(parseAsInteger).withDefault(AREA_SWEDEN),
  areaParent: parseAsInteger,
};
const urlKeys = {
  areaMode: 'area-mode',
  areaIds: 'area-ids',
  areaParent: 'area-parent',
};

const extendedAreaLoader = createLoader(keyMaps, { urlKeys: urlKeys });

export { extendedAreaLoader, keyMaps, urlKeys };
